import { useTranslation } from 'react-i18next';
import CompletedProjectProposalViewList from 'features/CompletedProjectProposal/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { Can } from 'components/Can';

function CompletedProjectProposalListPage() {
  const { t } = useTranslation();

  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="project">
            <CompletedProjectProposalViewList />
          </Can>
          <Can not do="read" on="project">
            <h4 className="text-red-500">{t('permission.forbid.read.projectProposalList')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default CompletedProjectProposalListPage;
